import React from 'react';
import './_deals.scss';
import {
  getBackgroundImageUrl,
  getDiscountText,
  getSelectedMultipleSkuIndex,
} from 'hb-redux-store/util/miscellaneousServices';
import { Link } from 'react-router-dom';
import Button from '../../common/Button/Button';
import ButtonCounter from '../../common/Button/ButtonCounter';
import {
  postAddItem,
  postRemoveItem,
} from 'hb-redux-store/feature/cart/cart.action';
import { connect } from 'react-redux';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { notifyUser } from 'hb-redux-store/feature/products/product.action';
import { createProductUrl } from '../../../CPMapping';
import { showNonServiceableModal } from 'hb-redux-store/feature/modal/modal.action';
import Icon from '../../mweb/Icon/Icon';
import HighLightTags from '../../mweb/HighlightTags/HighlightTags';
import StockLeft from '../../common/StockLeft/StockLeft';
import MultipleSkuDropDown from '../MultipleSku/MultipleSkuDropDown';

class DealCard extends React.Component {
  state = {
    sku: this.props.product.skus[0],
    discountText: getDiscountText({
      product: this.props.product,
      isProduct: true,
    }),
    activeSkuIndex: 0,
  };

  componentDidMount() {
    const selectedSkuIndex = getSelectedMultipleSkuIndex(
      this.props.product.skus
    );
    this.setState({ sku: this.props?.product?.skus[selectedSkuIndex] });
  }

  toLink = createProductUrl(this.props.product.productId);

  successOpCb = msg => ({ sku, skuCount }) => {
    let newSku = {};
    this.props.product.skus.map(s => {
      if (s.sku === sku) {
        newSku = { ...s, inCartQuantity: skuCount };
      }
    });
    this.props.setAppNotification(msg);
    this.setState({ sku: newSku, opInProgress: false });
    console.log('After Add: ', this.props.cartSkus);
  };

  failOpCb = msg => ({ errorMessage = msg }) => {
    if (errorMessage !== 'Please select a location.')
      this.props.setAppNotification(errorMessage);
    this.setState({ opInProgress: false });
  };

  addToCart = () => {
    this.setState({ opInProgress: true }, () => {
      const { sku } = this.state;
      this.props.postAddItem({
        productId: this.props.product.productId,
        productName: this.props.product?.productName,
        price: sku?.salePrice ?? sku?.retailPrice,
        sku: sku?.sku,
        quantity: 1,
        source: this.props.source,
        isCart: this.props.source === 'cart',
        successOpCb: this.successOpCb('Item added to cart'),
        failOpCb: this.failOpCb('Error adding item to cart'),
      });
    });
  };

  removeFromCart = () => {
    this.setState({ opInProgress: true }, () => {
      const { sku } = this.state;
      this.props.postRemoveItem({
        productId: this.props.product.productId,
        productName: this.props.product?.productName,
        price: sku?.salePrice ?? sku?.retailPrice,
        sku: sku.sku,
        quantity: 1,
        source: this.props.source,
        isCart: this.props.source === 'cart',
        successOpCb: this.successOpCb('Item removed from cart'),
        failOpCb: this.failOpCb('Error removing item to cart'),
      });
    });
  };
  notify = () => {
    const { setAppNotification, showNonServiceableModal } = this.props;
    if (!this.props.loggedInState) {
      return setAppNotification('Please login to get notified.');
    }
    this.props.notifyUser({
      sku: this.state.sku.sku,
      errorCb: e => {
        const message =
          e.data?.description ||
          e.data?.error?.errorMessage ||
          'Unable to process your request';
        if (e.status === 401) {
          setAppNotification('Please login to get notified.');
        }
        if (e.status === 500 && message === 'Please select a location.') {
          showNonServiceableModal({ visible: true, source: 'notifyMe' });
        }
      },
    });
  };

  render() {
    const { product, cartSkus } = this.props;
    const { sku, discountText } = this.state;
    const skuCartQty = cartSkus[sku.sku] ?? sku.inCartQuantity;
    return (
      <div className="deal-card-desktop">
        <div className="deal-card-desktop--align-top">
          <Link
            className={`deal-card-desktop--product-image
              ${!sku.isInventoryAvailable ? 'sold-out' : ''}
            `}
            style={getBackgroundImageUrl(product.productImage)}
            to={this.toLink}
          ></Link>
          {!sku.isInventoryAvailable && (
            <div className="deal-card-desktop--sold-out-tag">OUT OF STOCK</div>
          )}
          {sku.onSale && discountText && (
            <div className="deal-card-desktop--sale-tag">
              <Icon class="icon-cart-on-sale" size={18} />
              {discountText}
            </div>
          )}
          {product.isBestSeller && <HighLightTags type="bestseller" />}
          <Link className="deal-card-desktop--product-name" to={this.toLink}>
            {product.productName}
          </Link>
        </div>
        {sku.stockLeft && <StockLeft message={sku.stockLeft} />}
        <MultipleSkuDropDown
          product={product}
          sku={sku}
          activeSkuIndex={this.state.activeSkuIndex}
          setActiveSkuIndex={index => {
            this.setState({
              activeSkuIndex: index,
              sku: product?.skus[index],
            });
          }}
        />
        <div className="deal-card-desktop--button-price-div">
          <div>
            <span
              className={`deal-card-desktop--retail-price ${
                sku.onSale && sku.salePrice ? 'on-sale' : ''
              }`}
            >
              &#8377;{sku.retailPrice}
            </span>
            {sku.onSale && sku.salePrice && (
              <span className="deal-card-desktop--sale-price">
                &#8377;{sku.salePrice}
              </span>
            )}
          </div>
          <span className="deal-card-desktop--atc-button">
            {!sku.isInventoryAvailable && (
              <Button
                className="button button-ghost sold-out"
                onClick={this.notify}
              >
                Notify Me
              </Button>
            )}
            {sku.isInventoryAvailable && skuCartQty === 0 && (
              <Button
                className="button button-ghost"
                onClick={this.addToCart}
                disabled={this.state.opInProgress}
              >
                ADD
              </Button>
            )}
            {sku.isInventoryAvailable && skuCartQty > 0 && (
              <ButtonCounter
                className="button-counter-ghost deal-card-desktop--counter-btn"
                onIncrement={this.addToCart}
                onDecrement={this.removeFromCart}
                disabled={this.state.opInProgress}
                counter={skuCartQty}
              />
            )}
          </span>
        </div>
        {/*{sku.stockLeft && <StockLeft message={sku.stockLeft} />}*/}
      </div>
    );
  }
}
const mapStateToProps = ({ initialReducer, cartReducer }) => ({
  loggedInState: initialReducer.launchInfo.loggedIn,
  cartSkus: cartReducer.cartSkus,
});

const mapDispatchToProps = {
  postAddItem,
  postRemoveItem,
  setAppNotification,
  notifyUser,
  showNonServiceableModal,
};
export default connect(mapStateToProps, mapDispatchToProps)(DealCard);
